export default "__VITE_ASSET__df77fe0f__"